import { useCallback, useEffect, useState } from 'react';
import './BlurScreenWhenInactive.css';

const isDev = import.meta.env.DEV;

const BlurScreenWhenInactive = () => {
  const [inactive, setInactive] = useState(false);
  const [resetButtonClicked, setResetButtonClicked] = useState(false);

  const inactivityTime = isDev ? 1000 * 30 * 60 : 90 * 1000; // 90 seconds in milliseconds
  let inactivityTimeout;

  // biome-ignore lint/correctness/useExhaustiveDependencies: Full control of what triggers this code is needed
  const startInactivityTimer = useCallback(() => {
    inactivityTimeout = setTimeout(() => {
      setInactive(true);
    }, inactivityTime);
  }, [inactivityTime]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: Full control of what triggers this code is needed
  const resetInactivityTimer = useCallback(() => {
    clearTimeout(inactivityTimeout);
    startInactivityTimer();
    setInactive(false); // Reset the inactive state to false
    setResetButtonClicked(false); // Reset the reset button state
  }, [startInactivityTimer]);

  useEffect(() => {
    // Add event listeners to track user activity
    const handleMouseMove = () => !inactive && resetInactivityTimer();
    const handleKeyDown = () => !inactive && resetInactivityTimer();
    const handleScroll = () => !inactive && resetInactivityTimer();

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('scroll', handleScroll);

    // Start the inactivity timer when the component mounts
    startInactivityTimer();

    // Clean up event listeners and the inactivity timeout when the component unmounts
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(inactivityTimeout);
    };
  }, [inactive, inactivityTimeout, resetInactivityTimer, startInactivityTimer]);

  if (!inactive) return <></>;

  return (
    <button
      type="button"
      className="blur-screen"
      onClick={() => {
        setResetButtonClicked(true);
        resetInactivityTimer();
        setInactive(false); // Reset the inactive state to false
      }}
      disabled={resetButtonClicked}
    >
      -
    </button>
  );
};

export default BlurScreenWhenInactive;
